/**
 * @packageDocumentation
 * @module dom/attribute
 */

import set_attr, { TAttr } from './set_attr';

export type TAttrs = Record<string, TAttr>;

export interface SetAttrs {
  /**
   * set attributes on an element when appropriate, for performance
   *
   * @param el a html element to set attributes
   * @param attrs a dictionary of attribute name/value pairs
   */
  (el: Element, attrs: TAttrs): Element;
}

/**
 * { @link SetAttrs }
 */
export default (el: Element, attrs: TAttrs = {}): Element => {
  // @todo figure out if it is worth calling Object.keys on small objects
  for (const name in attrs) {
    set_attr(el, name, attrs[name]);
  }
  return el;
};
